import i18n from "@/i18n/i18nApp";

class ModalMessageHandler {

    constructor (store, event) {
        this.store = store;
        this.event = event;
        this.info;
        this.topic;
    }

    newMessage(topic, info) {
        this.setTopic(topic);
        this.setInfo(info);
        this.run();
    }

    setTopic(topic, translate = true) {
        this.topic = topic
        if(translate) {
            this.topic = this.getTranslation(topic)
        }
    }

    setInfo(info, translate = true) {
        this.info = info;
        if(translate) {
            this.info = this.getTranslation(info)
        }
    }

    getCursorPos() {
        let pos = {}
        pos.x = this.event.clientX
        pos.y = this.event.clientY
        return pos;
    }

    getTranslation(message) {
        if(message) {
            return i18n.global.t(message)
        }
    } 

    run() {
        if(!this.validateData()) {
            return
        }
        this.store.dispatch('app/newModalMessage', this)
    }

    validateData() {
        let validate = true;
        if(this.store == undefined) {
            console.error("Kein Store eingebunden")
            validate = false
        }
        if(this.event == undefined) {
            console.warn("Kein Event eingebunden")
            validate = false
        }
        if(this.topic == undefined) {
            console.warn("Keine Topic erhalten")
            validate = false
        }
        if(this.info == undefined) {
            console.warn("Keine Info erhalten")
            validate = false
        }
        return validate
    }
}


export default ModalMessageHandler